import Model from 'scripts/poppet/model';

/**
 * defa.models.AlarmCentral
 * The DEFA AlarmCentral model.
 * @version 1.2.0
 */
const AlarmCentral = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	defaults: {
		name: '',
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default AlarmCentral;